import Cookies from 'js-cookie';
import { store } from '../store/index';
import { clearCredentials } from '../store/slices/authSlice';

// Flag to prevent multiple redirects
let isRedirecting = false;

/**
 * Enhanced fetch wrapper with automatic token expiration handling
 * Use this for ALL API calls to ensure consistent 401/token expiration handling
 */
export const apiFetch = async (url, options = {}) => {
  const token = Cookies.get('access_token');
  
  // Add Authorization header if token exists
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  const response = await fetch(url, {
    ...options,
    headers,
  });
  
  // Handle 401 (Unauthorized) - token expired or invalid
  if (response.status === 401) {
    if (!isRedirecting) {
      isRedirecting = true;
      
      // Clear auth state
      store.dispatch(clearCredentials());
      Cookies.remove('access_token');
      
      // Small delay to ensure state updates
      setTimeout(() => {
        window.location.href = '/login';
      }, 100);
    }
    
    // Throw error to stop execution
    throw new Error('Session expired. Please login again.');
  }
  
  return response;
};

